import React from "react";
import { useTranslation } from 'react-i18next';
import { useAuth } from "../../hooks/auth";
import { Supplier } from "../../interfaces/Supplier";
import SupplierApi from "../../services/SupplierApi";
import Select from "./Select";

type ComboProps = any;

const SelectSupplier: React.FC<ComboProps> = ({ name, control, multiple, defaultValue, style, serviceType, label, onChange, disabled, setValue, loadUserSupplier, indCDLC, selectCreateComponent = true}) => {
  const { user, isFiasa, isPortoReal } = useAuth();
  const { t: _t } = useTranslation("General");
  //const [ defaultOptions, setDefaultOptions ] = useState<any>([]);

   let defaultOptions: any[] = [];

   if (user.isSupplier && serviceType != "T")
    {
      defaultOptions = user.suppliers;
      loadUserSupplier = (loadUserSupplier === undefined) ? true : loadUserSupplier;

      //Se User Fornecedor tiver um unico fornecedor selecionavel, desabilitar o campo para que ja fique selecionado
      if (loadUserSupplier && defaultOptions.length === 1 && setValue !== undefined)
      {
        disabled = true;
        let selectedSupplier = (multiple ? defaultOptions : defaultOptions[0]);
        setValue(name, selectedSupplier);
        if (onChange) onChange(selectedSupplier);
      }
    }

  const handleSearchSupplier = async(val: any) => {
    let items: any[] = [];
    let systemID = 10;

    if (user.isSupplier && serviceType !== "T")
      items = defaultOptions;
    else

      await SupplierApi.search(val, user.company.plantID, serviceType, systemID, indCDLC)
      .then(result => {
        items = result.items.map((supplier: Supplier) => {
          //Nota: Qualquer propriedade que precisar ser adicionada neste return, precisa tambem ser adicionada no hook Auth.tsx (user.suppliers), para que Usuarios Fornecedores tenham as mesmas propriedades:
          return { 
                //label: supplier.supplierID + " - " + supplier.name.trim() + (serviceType === "T" ? "" : supplier.systemSuppliers[0]?.isJIT ? " - JIT" : " - Não-JIT"),
                label: `${supplier.supplierID} - ${supplier.name.trim()} ${serviceType === `T` ? ` - ` + supplier.cnpj + (supplier.locality && supplier.locality.trim() ? ` (` + supplier.locality.trim() + `/` + supplier.region + `)` : ``) : (isPortoReal() ?  ` - ` + (supplier.codeSupplierCompany && supplier.codeSupplierCompany.trim() ? supplier.codeSupplierCompany + ` - ` : ``) + supplier.cnpj : ``) + (isFiasa() ? (supplier.systemSuppliers[0]?.isJIT ? ` - JIT` : ` - Não JIT`) : ``)} `,
                code: supplier.supplierID,
                name: supplier.name.trim(),
                cnpj: supplier.cnpj,
                companyId: supplier.companyID,
                uf: supplier.region,
                supplierUf: supplier.region,
                cdlcCode: supplier.codeSupplierCDLC,
                mainframeCode: supplier.codeSupplierMainframe,
                scacCode: supplier.codeSupplierSCAC,
                sapCode: supplier.supplierSAP
            };
          })
        });

      return items;
  }

  return (
    <Select
      disabled={disabled}
      allowSelectValueNotFound={false}
      label={label ? label : _t("supplier")} 
      name={name}
      control={control} 
      options={defaultOptions}
      style={style}
      setValue={setValue}
      searchFunction={defaultOptions.length == 0 && selectCreateComponent == true ? handleSearchSupplier : null}
      defaultValue={defaultValue}
      multiple={multiple} 
      onChange={onChange}
      />
  )
}

export default SelectSupplier;
